export const companyLegalTypeList = [
    { label: 'Ατομική', value: 'Ατομική', id: 'legal0' },
    { label: 'Ομόρρυθμη Εταιρεία', value: 'Ομόρρυθμη Εταιρεία', id: 'legal1' },
    { label: 'Ετερόρρυθμη Εταιρεία', value: 'Ετερόρρυθμη Εταιρεία', id: 'legal2' },
    {
      label: 'Εταιρεία Περιορισμένης Ευθύνης',
      value: 'Εταιρεία Περιορισμένης Ευθύνης',
      id: 'legal3'
    },
    {
      label: 'Ιδιωτική Κεφαλαιουχική Εταιρεία',
      value: 'Ιδιωτική Κεφαλαιουχική Εταιρεία',
      id: 'legal4'
    },
    { label: 'Ανώνυμη Εταιρεία', value: 'Ανώνυμη Εταιρεία', id: 'legal5' },
    {
      label: 'Κοινωνική Συνεταιριστική Επιχείρηση',
      value: 'Κοινωνική Συνεταιριστική Επιχείρηση',
      id: 'legal6'
    },
    { label: 'Άλλο', value: 'Άλλο', id: 'legal7' },
];